// Quando o card de Compras aparece e quando mostra o botão de acionar (decisões da Adneia de
// 20/10/2026). Mora aqui, sem tela, para o CardCompras e o quadro do vinho (SecaoAnotacoes)
// usarem a mesma conta: o quadro roxo só some quando o card mostra mesmo o "Acionar Flávia"
// (ressalva da revisão de 29/10/2026).

// Quem vê o botão: só a Adneia (30/10/2026, por clique: "Só Caio e Gabriela" deixam de ver). O texto
// pronto já vai no e-mail do dia para ela, e o "O que fazer" diz que a gestão aciona compras: com o
// botão na tela, o atendente ficava sem saber se acionava. Antes (decisão 3 de 20/10), os três. O
// servidor também barra.
export const ACIONAR_COMPRAS_EMAILS = ['adneia@weconnect360.com.br'];

// A lista de sexta vale até a rodada de segunda; mais velho que isso, o atendimento saiu da
// regra (não está mais em Aguardando estoque) e o card não aparece.
export const DIAS_VALE = 4;

export const idadeEmDias = (iso, agora = new Date()) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '');
  if (!m) return Infinity;
  const dia = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const hoje = new Date(agora.getTime());
  hoje.setHours(0, 0, 0, 0);
  return Math.round((hoje - dia) / 86400000);
};

export function cardComprasAparece(selo, agora = new Date()) {
  return !!(selo && selo.curto && selo.data_lista) && idadeEmDias(selo.data_lista, agora) <= DIAS_VALE;
}

export function mostraBotaoAcionar(selo, chamadoId, email, agora = new Date()) {
  if (!cardComprasAparece(selo, agora)) return false;
  return !!selo.curto.acionar && !!chamadoId
    && ACIONAR_COMPRAS_EMAILS.includes(String(email || '').trim().toLowerCase());
}
